import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@dfh-corp-sites/ui'
import { ChevronUp } from 'lucide-react'
import React from 'react'

import { SanityFaq, SanityFaqQuestion } from '../../graphql/gatsby'
import { useSanityRoleBasedContent } from '../../lib/sanity'
import BodyPortableText from './BodyPortableText'

const FAQ: React.FC<SanityFaq> = ({ title, questions }) => {
  return (
    <div className="bg-brand-gre [&:not(:has(.accordion-item))]:hidden">
      <div className="flex flex-col xl:flex-row gap-6 px-6 py-12 max-w-7xl mx-auto">
        <span className="text-balance text-3xl xl:text-4xl xl:min-w-[460px] font-medium flex-shrink-0 flex-grow-0">
          {title}
        </span>
        {questions?.length && (
          <Accordion type="multiple" className="flex-1">
            {questions?.reduce((acc, question) => {
              if (!question) return acc

              acc?.push(<FAQQuestion key={question._key} {...question} />)
              return acc
            }, [] as React.ReactNode[])}
          </Accordion>
        )}
      </div>
    </div>
  )
}

const FAQQuestion: React.FC<SanityFaqQuestion> = ({ _key, question, answer, roleBasedContent }) => {
  const { shouldDisplay } = useSanityRoleBasedContent({ roleBasedContent })
  if (!shouldDisplay) {
    return null
  }

  return (
    <AccordionItem
      className="bg-white border-none rounded-md mb-2.5 px-10 py-2 font-medium accordion-item"
      value={`${question}-${_key}`}
    >
      <AccordionTrigger
        className="!py-4 text-black text-left text-lg xl:text-[22px]"
        icon={
          <ChevronUp className="h-5 w-5 shrink-0 transition-transform rotate-180 duration-200 group-data-[state=open]:-rotate-180 md:group-data-[state=open]:rotate-0" />
        }
      >
        {question}
      </AccordionTrigger>
      <AccordionContent className="text-black/70 text-lg">
        <BodyPortableText blocks={answer} />
      </AccordionContent>
    </AccordionItem>
  )
}

export default FAQ
